import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/button/Button';
import TimeFrameButtons from './TimeFrameButtons';

const ProgressHeader = ({
    currentPeriod,
    selectedPeriod,
    switchPmPeriod,
    switchGrowthAnalysisPeriod,
    openBasicComprehensionWebEntry,
    showAddNew,
    periods,
    progressTab,
    basicComprehensionBtnLabel,
    GA,
    isDemoModeOn,
}) => (
    <div className="progress-header-container">
        <div className="time-frame-buttons">
            <TimeFrameButtons
                labelClassNames="btn-label"
                buttonClassNames="maze-btn"
                periods={periods}
                currentPeriod={currentPeriod}
                selectedPeriod={selectedPeriod}
                onPeriodClick={period =>
                    progressTab === GA.GROWTH_ANALYSIS
                        ? switchGrowthAnalysisPeriod(period, progressTab)
                        : switchPmPeriod(period, progressTab)
                }
            />
        </div>
        {showAddNew && (
            <div className="pm-btn">
                <div className="btn-label">{basicComprehensionBtnLabel} scores</div>
                <Button
                    isDisabled={isDemoModeOn}
                    className="btn maze-btn"
                    text="Add new"
                    onClick={openBasicComprehensionWebEntry}
                />
            </div>
        )}
    </div>
);

ProgressHeader.defaultProps = {
    currentPeriod: '',
    selectedPeriod: '',
    showAddNew: false,
    periods: [],
    progressTab: '',
    basicComprehensionBtnLabel: 'Maze',
    GA: {},
    isDemoModeOn: false,
};

ProgressHeader.propTypes = {
    currentPeriod: PropTypes.string,
    selectedPeriod: PropTypes.string,
    switchPmPeriod: PropTypes.func.isRequired,
    openBasicComprehensionWebEntry: PropTypes.func.isRequired,
    switchGrowthAnalysisPeriod: PropTypes.func.isRequired,
    showAddNew: PropTypes.bool,
    periods: PropTypes.array,
    progressTab: PropTypes.string,
    basicComprehensionBtnLabel: PropTypes.string,
    GA: PropTypes.object,
    isDemoModeOn: PropTypes.bool,
};

export default ProgressHeader;
